(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(slider) {
      if (slider.dataset.heroInit === 'true') return;
      slider.dataset.heroInit = 'true';

      var track = slider.querySelector('.hero-banner__track');
      if (!track) return;
      var slides = track.querySelectorAll('.hero-banner__slide');
      if (slides.length <= 1) return;

      var dots = slider.querySelectorAll('.hero-banner__dot');
      var index = 0;
      var autoplay = slider.getAttribute('data-autoplay') === 'true';
      var speed = parseInt(slider.getAttribute('data-speed'), 10) || 5000;
      var timer = null;

      function updateDots() {
        dots.forEach(function (d, di) {
          d.classList.toggle('is-active', di === index);
        });
      }

      function goTo(i) {
        index = (i + slides.length) % slides.length;
        track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
        updateDots();
      }

      function next() {
        goTo(index + 1);
      }

      function start() {
        stop();
        if (autoplay) timer = setInterval(next, speed);
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      dots.forEach(function (d, di) {
        d.addEventListener('click', function () {
          goTo(di);
          start();
        });
      });

      var scrollTimeout;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== index) {
            index = i;
            updateDots();
          }
        }, 120);
      });

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);

      updateDots();
      start();
    }

    function initAll() {
      document.querySelectorAll('[data-hero-slider]').forEach(initSlider);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
